var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('LogoSvg',{attrs:{"alt":"logo"}}),(_vm.showTitle)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }